import { dataSelector } from '@nextiva/global-store';
import { useMutation } from 'react-query';
import { useSelector } from 'react-redux';

import { deleteCampaignAttachment } from 'services';

export const useDeleteFileAttachments = () => {
  const globalStoreData = useSelector(dataSelector);
  const corpAcctNbr = globalStoreData.user?.profileDTO?.corpAcctNbr;

  const mutation = useMutation((attachmentId: string) =>
    deleteCampaignAttachment(corpAcctNbr, attachmentId),
  );

  return mutation;
};
